import { CommonModule } from "@angular/common";
import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { BooksReviewService } from "src/app/dashboard/main/accountant/books-review/books-review.service";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";

@Component({
    selector: "class-typeahead",
    imports: [CommonModule, TypeaheadModule, FormsModule, TooltipModule],
    templateUrl: "./class-typeahead.component.html",
    styleUrl: "./class-typeahead.component.css"
})
export class ClassTypeaheadComponent implements OnInit {
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Input() model: any;
  classes: any[] = [];
  @Input() company: any = null;

  booksReviewService = inject(BooksReviewService);
  quickbooksIntegrationService = inject(QuickbooksIntegrationService);
  destroyRef = inject(DestroyRef);

  ngOnInit() {
    // this.quickbooksIntegrationService.retrieveClasses(this.company.id).then(
    //   (res: any) => {
    //     this.classes = res.classes;
    //   },
    //   (err: any) => {
    //     console.log(err);
    //     this.classes = [];
    //   },
    // );

    this.booksReviewService.companyClasses$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((classes) => {
        this.classes = classes;
      });
  }

  classSelected(event: any) {
    this.onSelect.emit(event.item);
  }
}
